const convertImageURL = (url: string) => {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  return `${process.env.REACT_APP_BACKEND_URL}/${url}`;
};

export { convertImageURL };
